import { useEffect } from 'react';
import styles from './index.module.scss';
// import { toastText } from 'utils/utils';
// import { getApi } from 'redux/apis';
import { destroyNotification } from 'utils/notification';

const LoginLayoutBody = () => {
	// const intuitLoginHandler = async () => {
	// 	try {
	// 		localStorage.setItem('isLogin', 'true');
	// 		const response = await getApi('/quickbooks/sso-authurl');
	// 		window.open(response.data.data, '_self');
	// 	} catch (err) {
	// 		toastText('Something went wrong in login.', 'error');
	// 	}
	// };
	useEffect(() => {
		destroyNotification('quickbooks-reauthorization-required');
	}, []);

	useEffect(() => {
		// CAP-10: Remove any existing widget instance on mount to prevent duplicate
		// injection on re-renders or client-side navigation to this page.
		const existing = document.getElementById('outseta-login-widget');
		if (existing) {
			existing.remove();
		}

		// CAP-10: Clear all Outseta tokens from storage before doing anything else.
		// Outseta caches token validity in sessionStorage under dynamic keys — if any
		// survive, Outseta initialises thinking the session is still valid and hides
		// the login widget via monitorDom.
		localStorage.removeItem('outsetaAccessToken');
		Object.keys(sessionStorage)
			.filter(key => key.startsWith('outseta'))
			.forEach(key => sessionStorage.removeItem(key));

		// CAP-10: Wait for window.Outseta to be ready, clear its in-memory auth state,
		// THEN append the widget div. This is the critical ordering — monitorDom
		// evaluates auth state the moment it sees the widget div in the DOM. By
		// appending the div only after setAccessToken(null) has taken effect, we
		// guarantee monitorDom's first evaluation sees no token and renders the widget
		// visible. Appending before this point loses a timing race against monitorDom.
		let attempts = 0;
		const maxAttempts = 20;
		const intervalId = setInterval(() => {
			attempts++;
			const outseta = (window as any).Outseta;
			if (outseta) {
				clearInterval(intervalId);
				try { outseta.setAccessToken(null); } catch (e) { /* ignore */ }
				// CAP-10: Call nocode.refresh() after clearing the token so monitorDom
				// re-evaluates auth state and shows the widget. Required when Outseta
				// is already initialized with an active session (token expiry case).
				try { outseta.nocode?.refresh(); } catch (e) { /* ignore */ }

				const div = document.createElement('div');
				div.setAttribute('data-o-auth', '1');
				div.setAttribute('data-mode', 'embed');
				if (process.env.REACT_APP_OUTSETA_PLAN_UID_2) {
					div.setAttribute('data-plan-uid', process.env.REACT_APP_OUTSETA_PLAN_UID_2);
				}
				div.id = 'outseta-login-widget';
				document.getElementById('outseta-login-container')?.appendChild(div);
			} else if (attempts >= maxAttempts) {
				clearInterval(intervalId);
			}
		}, 100);

		// Cleanup: cancel poll and remove widget on unmount
		return () => {
			clearInterval(intervalId);
			const widget = document.getElementById('outseta-login-widget');
			if (widget) {
				widget.remove();
			}
		};
	}, []);

	return (
		<div className={styles['login-wrapper']}>
			<div className={styles['login-content']}>
				<img
					src="/assets/images/cap-logo-2.png"
					alt="CAP Logo"
					className={styles['cap-logo']}
				/>
				<div
					id="outseta-login-container"
					className={styles['outseta-container']}
				/>
				{/* <div className={styles['intuit_button_container']}>
						<button
							onClick={intuitLoginHandler}
							className={styles['intuit_button']}
							type="button"
						>
							Sign in with Intuit
						</button>
					</div> */}
			</div>

			{/* <div className={styles['login-right']}>
				<img
					src="/assets/images/CAP-Login Image.png"
					alt="Login Illustration"
					className={styles['login-image']}
				/>
			</div> */}
		</div>
	);
};

export default LoginLayoutBody;
